module.exports = __webpack_public_path__ + "assets/img/banners5.45e48b13.jpg";